import React, { useContext, useEffect, useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { productApi } from 'api/product';
import { UserContext } from 'contexts/UserContext';
import { TabPanel } from 'shared';

import { LocationAccuracyTab } from './cycleCount/locationAccuracyTab';
import { LocationIssuesTab } from './cycleCount/locationIssuesTab';
import PartnerCycleCountTab from './cycleCount/partnerCycleCountTab';
import ReplenCycleCountTab from './cycleCount/replenCycleCountTab';
import { SkuCycleCountTab } from './cycleCount/skuCycleCountTab';

function CycleCount() {
    const [selectedTab, setSelectedTab] = useState('0');
    const { user } = useContext(UserContext);
    const [partnerFeatureEnabled, setPartnerFeatureEnabled] = useState(false);

    const handleTabChange = (event, value) => {
        setSelectedTab(value);
    };

    useEffect(() => {
        const setFeatureFlag = async () => {
            const response = await productApi.getIsFeatureOn('PARTNER_CYCLE_COUNT');
            if (response.status && response.data?.isFeatureOn) {
                setPartnerFeatureEnabled(true);
            }
        };
        setFeatureFlag();
    }, []);

    return (
        <Paper style={{ minHeight: '80vh' }}>
            <Tabs onChange={handleTabChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="Location_Accuracy_Tab" label="Location Accuracy" value="0" />
                {user.cycleCountManager && <Tab id="Location_Issues_Tab" label="Issue Locations" value="1" />}
                <Tab id="Sku_Cycle_Count_Tab" label="Sku Cycle Count" value="2" />
                {user.cycleCountManager && (
                    <Tab id="Replen_Cycle_Count_Tab" label="Replenishment Cycle Count" value="3" />
                )}
                {partnerFeatureEnabled && <Tab id="Partner_Cycle_Count_Tab" label="Partner Cycle Count" value="4" />}
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <LocationAccuracyTab />
            </TabPanel>
            {user.cycleCountManager && (
                <TabPanel selectedTab={selectedTab} index="1">
                    <LocationIssuesTab />
                </TabPanel>
            )}
            <TabPanel selectedTab={selectedTab} index="2">
                <SkuCycleCountTab />
            </TabPanel>
            {user.cycleCountManager && (
                <TabPanel selectedTab={selectedTab} index="3">
                    <ReplenCycleCountTab />
                </TabPanel>
            )}
            {partnerFeatureEnabled && (
                <TabPanel selectedTab={selectedTab} index="4">
                    <PartnerCycleCountTab />
                </TabPanel>
            )}
        </Paper>
    );
}

export { CycleCount };
